import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { AppIcon } from '../../home/icon';
import { Article, findArticle } from '../learn-content';

@Component({
  selector: 'app-article-view',
  standalone: true,
  imports: [RouterLink, AppIcon],
  templateUrl: './article-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../terms/terms.scss', './article-view.scss']
})
export class ArticleView {
  readonly article: Article;

  constructor() {
    const route = inject(ActivatedRoute);

    const slug = route.snapshot.data['slug'] as string;
    const article = findArticle(slug);
    if (!article) throw new Error(`Unknown article slug: ${slug}`);
    this.article = article;
  }
}
